export default "__VITE_ASSET__69729714__"